import { useMemo } from 'react';
import { Nullable } from '@sato/components';

import { api } from '@api';
import { SaunaShift } from '@models/sauna';
import { apartmentStore } from '@stores/apartmentStore';
import { MAX_SAUNA_SHIFTS } from '@views/sauna/sauna.constants';

import { useObservable } from './useObservable';
import { useOmaSATOSaunas } from './useOmaSATOSaunas';

export const useSauna = (saunaId: Nullable<string>) => {
  const {
    saunas,
    refetch: refetchReservations,
    isSuccess,
    ...data
  } = useOmaSATOSaunas();

  const sauna = useMemo(
    () => (saunaId ? saunas?.find((s) => s.resourceId === saunaId) : undefined),
    [saunas, saunaId]
  );

  const apartmentId = useObservable(() => apartmentStore.selectedApartmentID);

  // Prevent reserving if user has more than MAX_SAUNA_SHIFTS reservations
  const canReserve = (sauna?.reservations.length ?? 0) < MAX_SAUNA_SHIFTS;

  return {
    ...sauna,
    ...data,
    canReserve,
    isSuccess,
    refetchReservations,
    cancelReservation: async (saunaShift: SaunaShift) => {
      if (!apartmentId) return;

      await api.sauna.cancelReservation(saunaShift.reservationId, apartmentId);

      refetchReservations();
    },
  };
};
